import React from 'react';
import './LegalPages.css';

const PrivacyPage = () => {
  return (
    <div className="legal-page-wrapper">
      <header className="legal-header">
        <h1>Privacy Policy</h1>
        <p>Your privacy is important to us</p>
      </header>

      <main className="legal-page">
        <p>
          <strong>Redfox Digital</strong> highly prioritizes your concerns regarding online privacy and security during your visits and transactions on our website <a href="https://redfox-digital.vercel.app/">https://redfox-digital.vercel.app/</a>. We are committed to ensuring that the information you provide remains secure and is used appropriately.
        </p>

        <h3>1. Information We Collect</h3>
        <p>
          We collect essential information necessary to fulfill your requests, which may include:
        </p>
        <ul>
          <li>Name, mailing address, email, and phone number</li>
          <li>Details related to orders and inquiries</li>
          <li>Technical data such as IP address, browser type, and device info</li>
        </ul>

        <h3>2. Use of Information</h3>
        <p>We use your information to:</p>
        <ul>
          <li>Process your requests and orders</li>
          <li>Provide order and delivery updates</li>
          <li>Improve our products, services, and customer support</li>
          <li>Send promotional emails or offers (only with your consent)</li>
        </ul>

        <h3>3. Cookies</h3>
        <p>
          Our website uses cookies to enhance your experience. Cookies allow us to store your preferences and gather analytics on how you interact with our website. These cookies do not store sensitive information such as passwords or card details.
        </p>

        <h3>4. Security Measures</h3>
        <p>
          We implement strong security measures, including SSL encryption, to ensure the safety of your personal information. Access to your data is limited to authorized personnel only.
        </p>

        <h3>5. Data Sharing</h3>
        <p>
          We do not sell or rent your personal information to third parties. However, we may share it with trusted service providers for order fulfillment or analytics purposes under strict confidentiality agreements.
        </p>

        <h3>6. Policy Updates</h3>
        <p>
          This Privacy Policy may be updated periodically. All changes will be posted on this page with an updated “Effective Date” at the top. Your continued use of the site after changes are made constitutes acceptance of the new terms.
        </p>

        <h3>7. Your Rights</h3>
        <p>
          You may request to review, update, or delete your personal information at any time by contacting us.
        </p>

        <h3>8. Contact</h3>
        <p>
          If you have any questions or concerns about this Privacy Policy, please email us at <a href="mailto:redfoxdotin@gmail.com">redfoxdotin@gmail.com</a>.
        </p>
      </main>
    </div>
  );
};

export default PrivacyPage;
